import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setSingleCourseData } from "../../repository/slice";

function* getSingleCourseDataWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/statistic/course/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleCourseData(data));
        }
    } catch (error) {
        console.error("getSingleCourseDataWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleCourseDataWatcher() {
    yield takeLatest("@saga/GET_SINGLE_COURSE_DATA", getSingleCourseDataWorker);
};